const getRandomId = require('./random-id.js')
const extend = require('xtend')

module.exports = createPayload


function createPayload(data){
  return extend({
    // defaults
    id: getRandomId(),
    jsonrpc: '2.0',
    params: [],
    // user-specified
  }, data)
}



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/web3-provider-engine/util/create-payload.js
// module id = 649
// module chunks = 0 1 2